import qs from 'qs';
import { API_URL } from 'common/consts';

const apiUrl = (path: string, query?: Record<string, any>): string =>
  query
    ? `${API_URL}/${path}?${qs.stringify(query, { arrayFormat: 'brackets' })}`
    : `${API_URL}/${path}`;

export { apiUrl };
